module.exports = __webpack_public_path__ + "static/media/jaxa.3dddc730.jpg";